import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class CodeContainerType extends TrackableEntity {
    containerType: string = '';
    relatedType: string = '';           // merged typeCode
    isoCode: string = '';
    isoName: string = '';
    containerGrp: string = '';          // merged group
    description: string = '';
    length: string = '';
    height: string = '';
    inactive: boolean = false;
    u2Date: string | null = null;
    inactiveDate: string | null = null;
    updatedBy: string = '';
    inactiveBy: string = '';

    // for only font-end
    edit: boolean = false;
    view: boolean = false;

    constructor(init?:Partial<CodeContainerType>) {
        super();
        this.key='containerType';
        Object.assign(this, init);
        this.noTrackProps.push('edit', 'view');

    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return CodeContainerType.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'containerType': new DBMappingInfo({ field: 'F_TYPE', table: 'T_CODECONTAINER' }),
        'relatedType': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'isoCode': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'containerGrp': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'description': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'length': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'height': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'inactive': new DBMappingInfo({ field: 'F_n1', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'u2Date': new DBMappingInfo({ field: 'F_d1', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'inactiveDate': new DBMappingInfo({ field: 'F_d2', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'updatedBy': new DBMappingInfo({ field: 'F_c8', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),
        'inactiveBy': new DBMappingInfo({ field: 'F_c9', table: 'T_AOTHERINFO', tbName: 'T_CNTR', tbId: '0', type: 0, c1: '@ConType' }),

    };
}
